module.exports = __webpack_public_path__ + "img/20180815_145537_007.fb034531.jpg";